// ===============================
// Imports (all at top)
// ===============================

// App Logo and Background
import APP_LOGO from "../assets/images/logo.png";
import background from "../assets/images/background.jpg";

// Slider Images
import slider_customweb from "../assets/images/slider-images/customweb.jpg";
import slider_mobile from "../assets/images/slider-images/mobile.jpg";
import slider_posrestaurant from "../assets/images/slider-images/pos&restaurant.jpg";
import slider_webdevelopment from "../assets/images/slider-images/webdevelopment.jpg";

// FoodBurma Previews
import foodburma_preview_1 from "../assets/images/foodburma-previews/fb-1.png";
import foodburma_preview_2 from "../assets/images/foodburma-previews/fb-2.png";

// SayazawMaths Previews
import sayazaw_preview_1 from "../assets/images/saya-previews/sayarzaw.jpg"

// SayazawMaths DB
import sayazaw_db_1 from "../assets/images/sayazaw-dashboard/sayazaw_db_1.jpg"
import sayazaw_db_2 from "../assets/images/sayazaw-dashboard/sayazaw_db_2.jpg"
import sayazaw_db_3 from "../assets/images/sayazaw-dashboard/sayazaw_db_3.jpg"
import sayazaw_db_4 from "../assets/images/sayazaw-dashboard/sayazaw_db_4.jpg"
import sayazaw_db_5 from "../assets/images/sayazaw-dashboard/sayazaw_db_5.jpg"

//phone frame
import iphone_frame from "../assets/images/iphone-frame.png"

// LoveCar Previews
import lovecar_preview_1 from "../assets/images/lovecar-previews/lovecar-cbm.png";
import lovecar_preview_2 from "../assets/images/lovecar-previews/lovecar-coin.png";
import lovecar_preview_3 from "../assets/images/lovecar-previews/lovecar-discount.png";
import lovecar_preview_4 from "../assets/images/lovecar-previews/lovecar-homepage.png";

// OphirPOS Previews
import ophirpos_preview_1 from "../assets/images/ophirpos-previews/1.png";
import ophirpos_preview_2 from "../assets/images/ophirpos-previews/2.png";
import ophirpos_preview_3 from "../assets/images/ophirpos-previews/3.png";
import ophirpos_preview_4 from "../assets/images/ophirpos-previews/4.png";
import ophirpos_preview_5 from "../assets/images/ophirpos-previews/5.png";
import ophirpos_preview_6 from "../assets/images/ophirpos-previews/6.png";
import ophirpos_preview_7 from "../assets/images/ophirpos-previews/7.png";
import ophirpos_preview_8 from "../assets/images/ophirpos-previews/8.png";

// StarGrade Previews
import stargrade_preview_1 from "../assets/images/stargrade-previews/1.png";

// Project Logos
import call2clean_logo_img from "../assets/images/project-logos/call2clean.jpg";
import foodburma_logo_img from "../assets/images/project-logos/foodburma.webp";
import lovecar_logo_img from "../assets/images/project-logos/lovecar.webp";
import ophirpos_logo_img from "../assets/images/project-logos/ophirpos.jpg";
import sayazawmaths_logo_img from "../assets/images/project-logos/sayazawmaths.png";
import stargrade_logo_img from "../assets/images/project-logos/stargrade.webp";
import zogenealogy_logo_img from "../assets/images/project-logos/zogenealogy.png";

//icon pngs
import icon1 from "../assets/images/icon1.png"
import icon2 from "../assets/images/icon2.png"
import icon3 from "../assets/images/icon3.png"
import icon4 from "../assets/images/icon4.png"
import icon5 from "../assets/images/cleaning.png"

// ==================
// Arrays & Exports
// ==================

export const slider_images = [
  slider_customweb,
  slider_mobile,
  slider_posrestaurant,
  slider_webdevelopment,
];

export const foodburma_previews = [foodburma_preview_1,foodburma_preview_2];

export const sayazaw_previews = [sayazaw_preview_1];

export const sayazaw_dashboard = [sayazaw_db_1, sayazaw_db_2, sayazaw_db_3, sayazaw_db_4, sayazaw_db_5];

export const frame = [iphone_frame];

export const lovecar_previews = [
  lovecar_preview_1,
  lovecar_preview_2,
  lovecar_preview_3,
  lovecar_preview_4,
  // lovecar_preview_5,
];

export const ophirpos_previews = [
  ophirpos_preview_1,
  ophirpos_preview_2,
  ophirpos_preview_3,
  ophirpos_preview_4,
  ophirpos_preview_5,
  ophirpos_preview_6,
  ophirpos_preview_7,
  ophirpos_preview_8,
];

export const stargrade_previews = [stargrade_preview_1];

export const project_logos = [
  call2clean_logo_img,
  foodburma_logo_img,
  lovecar_logo_img,
  ophirpos_logo_img,
  sayazawmaths_logo_img,
  stargrade_logo_img,
  zogenealogy_logo_img,
];

// Individual exports if needed
export {
  APP_LOGO,
  background,
  call2clean_logo_img as call2clean_logo,
  foodburma_logo_img as foodburma_logo,
  lovecar_logo_img as lovecar_logo,
  ophirpos_logo_img as ophirpos_logo,
  sayazawmaths_logo_img as sayazawmaths_logo,
  stargrade_logo_img as stargrade_logo,
  zogenealogy_logo_img as zogenealogy_logo,
};

export const icon = [
  icon1,
  icon2,
  icon3,
  icon4
]

export const cleaning_icon = [icon5]